
import { Dropzone } from "dropzone";
import {setInfoValue} from "@/helpers/info-overview-helper";

let fileUploads = []
const element = '#divNotificationFileUpload'
let dropzone

export function initFileUpload(attributeID, totalFiles) {
    dropzone = new Dropzone(element, {
        headers: {
            'Cache-Control': null,
            'X-Requested-With': null,
        },
        addRemoveLinks: true,
        maxFiles: totalFiles,
        maxFilesize: 32,
        paramName: 'upload',
        dictRemoveFile: 'Verwijder bestand',
        dictCancelUpload: 'Bestand upload annuleren',
        dictFileTooBig: 'Het bestand is te groot ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.',
        dictMaxFilesExceeded: 'U kunt geen bestanden meer uploaden',
        url: window.kaartViewerUrl + '/admin/rest/openapi/' + window.websiteName + '/' + window.categoryName + '/mutation/uploadfile'
    })

    dropzone.on("success", file => {
        const fileUpload = JSON.parse(file.xhr.responseText)
        fileUploads.push(fileUpload.upload.id.fileName)

        if(getFileUploads().length === 1) {
            setInfoValue(attributeID, 'Er is 1 bestand toegevoegd')
        } else if(getFileUploads().length > 1) {
            setInfoValue(attributeID, 'Er zijn ' + getFileUploads().length + ' bestanden toegevoegd')
        } else {
            setInfoValue(attributeID, '')
        }
    })

    dropzone.on("removedfile", file => {
        const fileUpload = JSON.parse(file.xhr.responseText)

        var index = fileUploads.indexOf(fileUpload.upload.id.fileName);
        if (index !== -1) {
            fileUploads.splice(index, 1);
        }

        if(getFileUploads().length === 1) {
            setInfoValue(attributeID, 'Er is 1 bestand toegevoegd')
        } else if(getFileUploads().length > 1) {
            setInfoValue(attributeID, 'Er zijn ' + getFileUploads().length + ' bestanden toegevoegd')
        } else {
            setInfoValue(attributeID, '-')
        }
    })
}

export function getFileUploads() {
    return fileUploads
}

export function resetFileUploads() {
    fileUploads = []
    if(dropzone) {
        Dropzone.forElement(element).removeAllFiles(true)
    }
}
